import type Lenis from 'lenis'

export const lenisRef: { current: Lenis | null } = { current: null }
